import { ColumnType } from "@/queries/smart-tables/types";
import type { SmartTableImportOperationType } from "@/routes/smart-table/hooks/csv/csvOperationTypes";

export enum HistoryImportSource {
  Request = "request",
  Trace = "trace",
}

export interface HistoryImportColumnConfig {
  label: string;
  columnType: ColumnType;
  operationType: SmartTableImportOperationType;
  successMessage: string;
  queuedMessage: string;
  failureMessage: string;
  anchorImportLabel: string;
  cellImportTitle: string;
  cellImportActionLabel: string;
}

export const HISTORY_IMPORT_COLUMN_CONFIG: Record<HistoryImportSource, HistoryImportColumnConfig> =
  {
    [HistoryImportSource.Request]: {
      label: "Request",
      columnType: ColumnType.REQUEST,
      operationType: "request_history_import",
      successMessage: "Request history imported successfully",
      queuedMessage: "Request import queued",
      failureMessage: "Failed to start request import",
      anchorImportLabel: "Import Request",
      cellImportTitle: "Import Request into Cell",
      cellImportActionLabel: "Import Request",
    },
    [HistoryImportSource.Trace]: {
      label: "Trace",
      columnType: ColumnType.TRACE,
      operationType: "trace_import",
      successMessage: "Trace history imported successfully",
      queuedMessage: "Trace import queued",
      failureMessage: "Failed to start trace import",
      anchorImportLabel: "Import Trace",
      cellImportTitle: "Import Trace into Cell",
      cellImportActionLabel: "Import Trace",
    },
  };

export const HISTORY_IMPORT_SUCCESS_MESSAGES: Partial<
  Record<SmartTableImportOperationType, string>
> = {
  request_history_import: HISTORY_IMPORT_COLUMN_CONFIG[HistoryImportSource.Request].successMessage,
  trace_import: HISTORY_IMPORT_COLUMN_CONFIG[HistoryImportSource.Trace].successMessage,
};

export const isHistoryImportColumnId = (columnId: unknown): columnId is string =>
  typeof columnId === "string" && columnId.length > 0;

export const HISTORY_IMPORT_DIALOG_CLASS_NAME =
  "flex h-[85vh] max-w-[96vw] flex-col overflow-hidden sm:max-w-[1400px]";

export const MODAL_ABOVE_SHEET_Z_INDEX_CLASS = "z-[100]";
